import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { MaterialSymbols } from 'material-design-icons-literal-types';

interface Props {
  title: string;
  description: string;
  onButtonClick: () => void;
  icon: MaterialSymbols;
  buttonText: string;
  className?: string;
}

export const IconContainerWithButton = ({
  title,
  description,
  icon,
  onButtonClick,
  buttonText,
  className = '',
}: Props) => {
  return (
    <div
      onClick={onButtonClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onButtonClick();
        }
      }}
      role="button"
      tabIndex={0}
      className={`icon-container-with-button ${className}`}
    >
      <div className="icon-text-container">
        <div className="icon">
          <SharedIcon iconName={icon} />
        </div>
        <div className="title">{title}</div>
        <div className="description">{description}</div>
      </div>
      <div className="button-container">
        <button className="button" onClick={onButtonClick}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};
